/**
 * Comparación de opciones para los desplegables de los filtros.
 *
 * MUI v4 decide si una opción está elegida con `getOptionSelected`, que por defecto compara con
 * `===`: identidad de objeto. Eso alcanza mientras el valor elegido sea LA MISMA instancia que
 * salió de la lista de opciones, y en estos filtros casi nunca lo es:
 *
 *  - el valor por defecto se construye aparte (`getTicketsFilterDefaults`), no se toma de la lista;
 *  - lo que vuelve de `localStorage` pasó por `JSON.parse`, así que es un objeto nuevo.
 *
 * Sin esta comparación, el desplegable no reconoce lo que ya está elegido: la opción aparece sin
 * tilde y al clickearla **agrega un chip duplicado** en vez de quitarla. Se veía con el default
 * (dos veces PENDIENTES) y con cualquier filtro después de un F5.
 */

/**
 * Si dos opciones representan lo mismo. Compara por el identificador que traiga —`value` para los
 * selects, `id` para los períodos— y cae en la identidad de objeto si no hay ninguno.
 *
 * En el `pastableMultiselect` una entidad se identifica por `value` + `tipo`: los ids se repiten
 * entre móviles, llantas y personas, así que el móvil 12 y la llanta 12 son opciones distintas.
 */
export const mismaOpcion = (a, b) => {
	if (a === b) return true;
	if (!a || !b) return false;

	// Se comparan como texto, igual que hacía PastableMultiAutocomplete: un id puede volver de
	// localStorage o de otro endpoint como número o como string, y `12 === '12'` es false.
	if (a.tipo !== undefined || b.tipo !== undefined) {
		return String(a.value) === String(b.value) && a.tipo === b.tipo;
	}
	if (a.value !== undefined && b.value !== undefined) return String(a.value) === String(b.value);
	if (a.id !== undefined && b.id !== undefined) return String(a.id) === String(b.id);

	return false;
};

export default mismaOpcion;
